import {
  preventNegativeValues,
  preventPasteNegative,
} from "edviron-ui-package";
import React, { ChangeEvent, useEffect, useState } from "react";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import KeyValueList, { KeyValueItem } from "./KeyValueList";
import VendorDropDown from "../Transaction/components/AllFilter/ActiveVendor";
import StudentUploadCSV from "./StudentUploadCSV/StudentUploadCSV";
import Select from "react-select";
import CreateDropDown from "./CreateDropDown";
import {
  CREATE_PAYMENT_FORM,
  GET_MERCHANT_PAYMENT_FORMS,
  GET_USER,
  UPLOAD_STUDENTS_CSV,
} from "../../../Qurries";
import { useApolloClient, useMutation, useQuery } from "@apollo/client";
import { toast } from "react-toastify";
export type GetFormProps = {
  amount: number;
  name: string;
  email: string;
  phoneNo: string;
  callbackUrl: string;
  webhookUrl: string;
  amountType: string;
  base64: string | null;
  additional_data: {};
  extension: string;
  heading: string;
  school_name: string | null;
  desc: string;
  school_id: string | null;
  vendors_info: {
    vendor_id: string;
    percentage: number;
  };
  attachment_name?: string;
  instagram_link?: string;
  facebook_link?: string;
};

type OptionType = { label: string; value: string };
const MIN_PAYMENT_FORM_AMOUNT = 500;

const AVAILABLE_FIELDS: OptionType[] = [
  { label: "Student Name", value: "student_name" },
  { label: "Student Email", value: "student_email" },
  { label: "Student Phone", value: "student_phone_no" },
  { label: "Roll Number", value: "roll_number" },
  { label: "Age", value: "age" },
  { label: "Class", value: "class" },
  { label: "Section", value: "section" },
  { label: "Gender", value: "gender" },
  { label: "Category", value: "category" },
  { label: "Date of Birth", value: "dob" },
  { label: "Date of Admission", value: "date_of_addmission" },
  { label: "Blood Group", value: "blood_group" },
  { label: "Address Line 1", value: "address_line1" },
  { label: "Address Line 2", value: "address_line2" },
  { label: "City", value: "city" },
  { label: "State", value: "state" },
  { label: "PIN", value: "pin" },
  { label: "Country", value: "country" },
  { label: "Aadhar Number", value: "aadhar_number" },
  { label: "PAN Number", value: "pan_number" },
  { label: "School Generated ID", value: "school_generated_id" },
  { label: "Father Name", value: "father_name" },
  { label: "Father Contact Number", value: "father_contact_number" },
  { label: "Father Email ID", value: "father_email_id" },
  {
    label: "Father Education Qualification",
    value: "father_education_qualification",
  },
  { label: "Father Occupation", value: "father_occupation" },
  { label: "Father Work Organization", value: "father_work_organization" },
  { label: "Father Designation", value: "father_designation" },
  { label: "Father Annual Income", value: "father_annual_income" },
  { label: "Mother Name", value: "mother_name" },
  { label: "Mother Contact Number", value: "mother_contact_number" },
  { label: "Mother Email ID", value: "mother_email_id" },
  {
    label: "Mother Education Qualification",
    value: "mother_education_qualification",
  },
  { label: "Mother Occupation", value: "mother_occupation" },
  { label: "Mother Work Organization", value: "mother_work_organization" },
  { label: "Mother Designation", value: "mother_designation" },
  { label: "Mother Annual Income", value: "mother_annual_income" },
  { label: "Guardian Name", value: "guardian_name" },
  { label: "Guardian Contact Number", value: "guardian_contact_number" },
  { label: "Guardian Email ID", value: "guardian_email_id" },
  { label: "Guardian Relationship", value: "guardian_relationship" },
  {
    label: "Guardian Education Qualification",
    value: "guardian_education_qualification",
  },
  { label: "Guardian Occupation", value: "guardian_occupation" },
  { label: "Guardian Work Organization", value: "guardian_work_organization" },
  { label: "Guardian Designation", value: "guardian_designation" },
  { label: "Guardian Annual Income", value: "guardian_annual_income" },
  { label: "Religion", value: "religion" },
  { label: "Nationality", value: "nationality" },
  { label: "BPL Student", value: "bpl_student" },
  { label: "BPL Card Number", value: "bpl_card_number" },
  { label: "Person with Disability", value: "person_with_disability" },
  { label: "Type of Disability", value: "type_of_disability" },
  { label: "Identification Mark", value: "identification_mark" },
  { label: "Mother Tongue", value: "mother_tougue" },
  { label: "Second Language", value: "second_language" },
  { label: "Emergency Contact Number", value: "emergency_contact_number" },
  { label: "Single Parent Child", value: "single_parent_child" },
  { label: "Sponsored Student", value: "sponsored_student" },
  { label: "Sponsored Name", value: "sponsored_name" },
  { label: "Bank Name", value: "bank_name" },
  { label: "Bank Account Number", value: "bank_account_number" },
  { label: "IFSC Code", value: "ifsc_code" },
  { label: "Account Holder Name", value: "account_holder_name" },
  { label: "Weight", value: "weight" },
  { label: "Height", value: "height" },
  { label: "BMI", value: "bmi" },
  { label: "Allergies", value: "allergies" },
  { label: "School Name", value: "school_name" },
  { label: "School Address", value: "school_address" },
  { label: "Board", value: "board" },
  { label: "Medium of Instruction", value: "medium_of_instruction" },
  { label: "TC Number", value: "tc_number" },
  { label: "Last Class Passed", value: "last_class_passed" },
  {
    label: "Percentage of Last Class Passed",
    value: "percentage_of_last_class_passed",
  },
  { label: "Has Sibling", value: "has_sibling" },
];

export default function CreateForm() {
  const client = useApolloClient();
  const [schoolId, setSchoolId] = React.useState<string | null>(null);
  const [selectSchool, setSelectSchool] = React.useState<string | null>(null);
  const [fileName, setFileName] = useState<string>("");
  const [base64, setBase64] = useState<string>("");
  const [isSplitPayment, setIsSplitPayment] = useState<boolean>(false);
  const [fileExt, setFileExt] = useState<string>("");
  const [selectedFields, setSelectedFields] = useState<OptionType[]>([]);
  const [formMode, setFormMode] = useState<"csv" | "manual">("manual");
  const [dropdowns, setDropdowns] = useState([{ heading: "", values: [""] }]);
  const [isDropdonwnAdded, setIsDropdownAdded] = useState(false);
  const [hasAttachment, setHasAttachment] = useState(false);

  const { data } = useQuery(GET_USER);
  useEffect(() => {
    if (data?.getMerchantQuery) {
      setSchoolId(data.getMerchantQuery.school_id || null);
      setSelectSchool(data.getMerchantQuery.name || null);
    }
  }, [data]);

  const [formData, setFormData] = useState<GetFormProps>({
    amount: 0,
    name: "",
    email: "",
    phoneNo: "",
    callbackUrl: "",
    webhookUrl: "",
    amountType: "fixed",
    base64: base64,
    additional_data: {},
    extension: fileExt,
    heading: "",
    school_name: selectSchool || "",
    school_id: schoolId || "",
    desc: "",
    vendors_info: {
      vendor_id: "",
      percentage: 0,
    },
    attachment_name: "",
    instagram_link: "",
    facebook_link: "",
  });

  const [items, setItems] = useState<KeyValueItem[]>([{ key: "", value: "" }]);
  const [open, setOpen] = useState(false);
  const [collectRequestUrl, setCollectRequestUrl] = useState<string>("");
  const [csvFileName, setCsvFileName] = useState<string>("");
  const [csvBase64, setCsvBase64] = useState<string>("");
  const [uploadStudentsExcelMerchant, { loading: uploadLoading }] =
    useMutation(UPLOAD_STUDENTS_CSV);
  const [createPaymentForm, { loading }] = useMutation(CREATE_PAYMENT_FORM, {
    onCompleted: async (data) => {
      const url = data?.createMerchantPaymentForm?.url;
      const formId = data?.createMerchantPaymentForm?.form_id;
      if (formMode === "csv" && csvBase64 && schoolId && formId) {
        await uploadStudentsExcelMerchant({
          variables: {
            data: { file: csvBase64, filename: csvFileName },
            school_id: schoolId,
            form_id: formId,
          },
        });
      }
      setCollectRequestUrl(url);
      setOpen(true);
      toast.success("Payment form created successfully!");
      client.refetchQueries({
        include: [GET_MERCHANT_PAYMENT_FORMS],
      });
    },
    onError: (error) => {
      toast.error(error?.message || "Failed to create payment form");
    },
  });

  const [isAdditional, setIsAdditional] = useState<boolean>(false);
  const [VendorId, setVendorId] = useState<string>("");

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name === "amount" ? Number(value) || 0 : value,
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const submittedAmount = Number(formData.amount) || 0;
    if (submittedAmount < MIN_PAYMENT_FORM_AMOUNT) {
      toast.warning(
        `Amount should be at least ${MIN_PAYMENT_FORM_AMOUNT} for both fixed and variable forms`,
      );
      return;
    }

    if (isSplitPayment) {
      if (VendorId === "") {
        toast.error("Please select at least one vendor for split payment.");
        return;
      }
    }
    try {
      const fieldsArray = selectedFields.map((field) => field.value);

      const additionalDataObj: Record<string, string> = {};
      items.forEach((item) => {
        if (item.key) {
          additionalDataObj[item.key] = item.value || "";
        }
      });

      const variables: any = {
        expires_in: 5,
        fields_show: fieldsArray,
        amount: submittedAmount,
        heading: formData.heading,
        desc: formData.desc,
        callback_url: formData.callbackUrl,
        webhook_url: formData.webhookUrl,
        amount_type: formData.amountType,
        base64,
        additional_data:
          Object.keys(additionalDataObj).length > 0
            ? JSON.stringify(additionalDataObj)
            : null,
        extension: fileExt,
        split_payment: isSplitPayment,
        payment_origin: "merchant",
        school_name: selectSchool || "",
        student_name: formData.name || null,
        student_email: formData.email || null,
        student_phone_no: formData.phoneNo || null,
        drop_down_options: isDropdonwnAdded ? dropdowns : null,
        attachment_name: formData.attachment_name || null,
        hasAttachment: hasAttachment,
        instagram_link: formData.instagram_link || null,
        facebook_link: formData.facebook_link || null,
      };

      if (isSplitPayment) {
        variables.vendor_info = {
          vendor_id: VendorId,
          percentage: 100,
        };
      }

      // console.log(variables, "variables");

      await createPaymentForm({ variables });
    } catch (err) {
      console.error("Error fetching payment form:", err);
      toast.error("Failed to create payment form. Please try again.");
    }
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setFileName(file.name);
    const ext = file.name.split(".").pop() || "";
    setFileExt(ext);

    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      setBase64(result);
    };
    reader.readAsDataURL(file);
  };

  const handleCsvFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    if (!file.name.endsWith(".csv")) {
      toast.error("Please select a CSV file");
      return;
    }

    setCsvFileName(file.name);

    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      setCsvBase64(result);
    };
    reader.readAsDataURL(file);
  };

  const handleClear = () => {
    setFileName("");
    setBase64("");
    setFileExt("");
  };

  return (
    <div className="flex  flex-col items-center justify-center   ">
      <div className="relative w-full ">
        <form className="space-y-4 max-h-[70vh] overflow-y-auto pb-10 px-2">
          <div className="w-full mb-6">
            <div className="flex justify-center rounded-lg w-full">
              <button
                type="button"
                onClick={() => setFormMode("manual")}
                className={`px-6 py-3 text-sm font-medium transition-all relative rounded-t-lg ${
                  formMode === "manual"
                    ? "text-[#1e1b59] bg-[#EFF6FF]"
                    : "text-[#1e1b59] hover:text-gray-700"
                }`}
              >
                Form without CSV
                {formMode === "manual" && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-0.5 bg-[#1e1b59]"></span>
                )}
              </button>

              <button
                type="button"
                onClick={() => setFormMode("csv")}
                className={`px-6 py-3 text-sm font-medium transition-all relative rounded-t-lg ${
                  formMode === "csv"
                    ? "text-[#1e1b59] bg-[#EFF6FF]"
                    : "text-[#1e1b59] hover:text-gray-700"
                }`}
              >
                Form with CSV
                {formMode === "csv" && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-0.5 bg-[#1e1b59]"></span>
                )}
              </button>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <span className="text-sm font-medium text-[#1E293B]">
              Split Payment?
            </span>

            <label className="flex items-center gap-2 text-sm">
              <input
                type="radio"
                name="splitPayment"
                checked={!isSplitPayment}
                onChange={() => setIsSplitPayment(false)}
              />
              No
            </label>

            <label className="flex items-center gap-2 text-sm">
              <input
                type="radio"
                name="splitPayment"
                checked={isSplitPayment}
                onChange={() => setIsSplitPayment(true)}
              />
              Yes
            </label>
          </div>
          {isSplitPayment && (
            <div>
              <label className="block text-sm font-medium mb-1 text-[#1E293B]">
                Select Vendor
              </label>

              <VendorDropDown setVendorId={(id) => setVendorId(id)} />
            </div>
          )}

          <div>
            <label
              htmlFor="form-heading"
              className="block text-sm font-medium mb-1 text-[#1E293B]"
            >
              Form Heading
            </label>
            <input
              type="text"
              name="heading"
              id="form-heading"
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
            />
          </div>
          <div>
            <label
              htmlFor="form-description"
              className="block text-sm font-medium mb-1 text-[#1E293B]"
            >
              Description
            </label>
            <textarea
              name="desc"
              id="form-description"
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
            />
          </div>

          <div>
            {formMode === "csv" && schoolId && (
              <StudentUploadCSV
                schoolId={schoolId}
                schoolName={selectSchool}
                handleFileChange={handleCsvFileChange}
              />
            )}
          </div>

          {/* Fields to Show Select */}

          {formMode === "manual" && (
            <div className="flex flex-col gap-4">
              {/* Student Name */}
              <div>
                <label
                  htmlFor="student-name"
                  className="block text-sm font-medium mb-1 text-[#1E293B]"
                >
                  Student Name
                </label>
                <input
                  type="text"
                  id="student-name"
                  name="student_name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, name: e.target.value }))
                  }
                  placeholder="Enter student name"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
                />
              </div>

              {/* Student Email */}
              <div>
                <label
                  htmlFor="student-email"
                  className="block text-sm font-medium mb-1 text-[#1E293B]"
                >
                  Student Email
                </label>
                <input
                  type="email"
                  id="student-email"
                  name="student_email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, email: e.target.value }))
                  }
                  placeholder="Enter student email"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
                />
              </div>

              {/* Student Phone */}
              <div>
                <label
                  htmlFor="student-phone"
                  className="block text-sm font-medium mb-1 text-[#1E293B]"
                >
                  Student Phone
                </label>
                <input
                  type="tel"
                  id="student-phone"
                  name="student_phone"
                  placeholder="Enter student phone number"
                  value={formData.phoneNo}
                  maxLength={10}
                  inputMode="numeric"
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    const pasted = e.clipboardData.getData("text");
                    if (!/^\d+$/.test(pasted)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const digits = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);

                    setFormData((prev) => ({
                      ...prev,
                      phoneNo: digits,
                    }));
                  }}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
                />
              </div>
            </div>
          )}
          <div>
            <label className="block text-sm font-medium mb-2 text-[#1E293B]">
              Fields to Show on Form
            </label>
            <Select
              isMulti
              name="fields_show"
              options={AVAILABLE_FIELDS}
              value={selectedFields}
              onChange={(option) => {
                setSelectedFields(option as OptionType[]);
              }}
              className="w-full"
              classNamePrefix="select"
              placeholder="Select fields to display..."
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: "#d1d5db",
                  minHeight: "40px",
                  fontSize: "14px",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "#1e1b59"
                    : state.isFocused
                      ? "#f3f4f6"
                      : "white",
                  color: state.isSelected ? "white" : "black",
                  cursor: "pointer",
                }),
                multiValue: (base) => ({
                  ...base,
                  backgroundColor: "#1e1b59",
                  borderRadius: "4px",
                }),
                multiValueLabel: (base) => ({
                  ...base,
                  color: "white",
                }),
                multiValueRemove: (base) => ({
                  ...base,
                  color: "white",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#8B8B8B",
                    color: "black",
                  },
                }),
              }}
            />
          </div>
          <div className="flex items-center space-x-4">
            <div className="flex items-center">
              <label htmlFor="fixed" className="mr-4 text-xs">
                Fixed
              </label>
              <input
                type="radio"
                onChange={handleChange}
                name="amountType"
                id="fixed"
                value="fixed"
              />
            </div>
            <div className="flex items-center">
              <label htmlFor="variable" className="mr-4 text-xs">
                Variable
              </label>
              <input
                type="radio"
                name="amountType"
                id="variable"
                value="variable"
                onChange={handleChange}
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="amount"
              className="block text-sm font-medium mb-1 text-[#1E293B]"
            >
              Amount
            </label>
            <input
              type="text"
              name="amount"
              id="amount"
              value={formData.amount}
              onChange={handleChange}
              required
              onKeyDown={preventNegativeValues}
              onPaste={preventPasteNegative}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
            />
          </div>

          {/* Callback URL */}
          <div>
            <label
              htmlFor="callbackUrl"
              className="block text-sm font-medium mb-1 text-[#1E293B]"
            >
              Callback URL (optional)
            </label>
            <input
              type="url"
              name="callbackUrl"
              id="callbackUrl"
              value={formData.callbackUrl}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 pr-10 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
            />
          </div>

          {/* Webhook URL */}
          <div>
            <label
              htmlFor="webhookUrl"
              className="block text-sm font-medium mb-1 text-[#1E293B]"
            >
              Webhook URL (optional)
            </label>
            <input
              type="url"
              name="webhookUrl"
              id="webhookUrl"
              value={formData.webhookUrl}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 pr-10 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
            />
          </div>
          <div>
            <label
              htmlFor="instagram-link"
              className="block text-sm font-medium mb-1 text-[#1E293B]"
            >
              Instagram Link (optional)
            </label>
            <input
              name="instagram_link"
              id="instagram-link"
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
            />
          </div>
          <div>
            <label
              htmlFor="facebook_link"
              className="block text-sm font-medium mb-1 text-[#1E293B]"
            >
              Facebook Link (optional)
            </label>
            <input
              name="facebook_link"
              id="facebook-link"
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
            />
          </div>

          <div className="w-full space-y-4">
            {/* Upload Box */}
            <label
              htmlFor="imgUpload"
              className="block w-full cursor-pointer border-2 border-dashed border-gray-300 rounded-xl p-4 text-center text-gray-600 hover:border-blue-500 transition"
            >
              <span className="block text-sm font-medium">
                {fileName ? "Change Image" : "Upload Image"}
              </span>
              {!fileName && (
                <span className="text-xs text-gray-400">
                  Click to choose file
                </span>
              )}
            </label>

            <input
              id="imgUpload"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
            />

            {/* Selected File Display */}
            {fileName && (
              <div className="flex items-center justify-between ">
                <span className="text-sm font-medium text-gray-700 truncate">
                  {fileName}
                </span>

                <button
                  onClick={handleClear}
                  className="text-red-500 text-sm font-semibold hover:text-red-600"
                >
                  Remove
                </button>
              </div>
            )}
          </div>
          <hr />
          <div className="flex">
            <input
              onChange={() => {
                setIsAdditional(!isAdditional);
              }}
              type="checkbox"
              checked={isAdditional}
              id="additional-details"
              className=""
            />
            <label
              htmlFor="additional-details"
              className="ml-2 block xl:text-sm text-xs font-medium text-gray-700"
            >
              Add Additional Details
            </label>
          </div>

          {isAdditional && <KeyValueList items={items} setItems={setItems} />}
          <div className="flex">
            <input
              onChange={() => {
                setIsDropdownAdded(!isDropdonwnAdded);
              }}
              type="checkbox"
              checked={isDropdonwnAdded}
              id="dropdown-details"
              className=""
            />
            <label
              htmlFor="dropdown-details"
              className="ml-2 block xl:text-sm text-xs font-medium text-gray-700"
            >
              Add Dropdown
            </label>
          </div>
          {isDropdonwnAdded && (
            <CreateDropDown dropDowns={dropdowns} setDropdowns={setDropdowns} />
          )}
          <div className="flex">
            <input
              onChange={() => {
                setHasAttachment(!hasAttachment);
              }}
              type="checkbox"
              checked={hasAttachment}
              id="attachment-details"
              className=""
            />
            <label
              htmlFor="attachment-details"
              className="ml-2 block xl:text-sm text-xs font-medium text-gray-700"
            >
              Has Attachment
            </label>
          </div>
          {hasAttachment && (
            <div className="mt-2">
              <label
                htmlFor="attachment"
                className="block text-sm font-medium mb-1 text-[#1E293B]"
              >
                Attachment Name
              </label>
              <input
                type="text"
                name="attachment_name"
                id="attachment"
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#1e1b59] outline-none"
              />
            </div>
          )}
        </form>
        <div className="py-4 bg-white w-full">
          <button
            type="submit"
            onClick={handleSubmit}
            className="px-4 py-1.5 !bg-purple-600 text-white w-full rounded"
          >
            {loading ? "Creating..." : "Create Payment Form"}
          </button>
        </div>
        <div
          className={`
          absolute transition-all w-full left-0 duration-300 
          ${
            open
              ? "opacity-100 -translate-y-[106px]"
              : "opacity-0 translate-y-0 pointer-events-none"
          }
        `}
        >
          <div className="w-full flex relative  items-center h-28 p-4 border bg-blue-100 shadow-lg rounded-xl mt-2">
            <span
              onClick={() => {
                setOpen(false);
              }}
              className=" absolute top-2 right-2 cursor-pointer"
            >
              X
            </span>
            <p className="truncate">{collectRequestUrl}</p>
            <span className="p-3 rounded-xl bg-black">
              <a
                href={collectRequestUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaArrowUpRightFromSquare className="text-white" />
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
